import React from "react";
import { PageLayout } from "../components/page-layout";
import { ManageTransfers } from "../components/admin/manage-transfers";
import PremPlayersProvider from "../providers/premplayers-provider";    

export const ManageTransfersPage = () => {
  return (
    <PremPlayersProvider>
        <PageLayout>
          <ManageTransfers />
        </PageLayout>
    </PremPlayersProvider>
  );
};